import MtownS1 from '../../../media/Apartement/Mtown Signature/Mtown Signature (1).webp'
import MtownS2 from '../../../media/Apartement/Mtown Signature/Mtown Signature (2).webp'
import MtownS3 from '../../../media/Apartement/Mtown Signature/Mtown Signature (3).webp'
import MtownS4 from '../../../media/Apartement/Mtown Signature/Mtown Signature (4).webp'
import MtownS5 from '../../../media/Apartement/Mtown Signature/Mtown Signature (5).webp'

const MtownSimages =[
MtownS1,MtownS2,MtownS3,MtownS4,MtownS5
]

export default MtownSimages;